import Request from 'utils/request.js';

const MANAGEMENT_BASE_URL = 'management/categories';
const STORE_BASE_URL = 'store/categories';

//Store
export const getMenuCategories = () => Request.get(`${STORE_BASE_URL}`);

// Management
export const getCategories = () => Request.get(`${MANAGEMENT_BASE_URL}`);
export const createCategory = (request) => Request.post(`${MANAGEMENT_BASE_URL}`, request);
export const updateCategory = (id, data) => Request.put(`${MANAGEMENT_BASE_URL}/${id}`, data);
export const deleteCategory = (id) => Request.delete(`${MANAGEMENT_BASE_URL}/${id}`);
export const updateCategoryOrders = (data) =>
  Request.post(`${MANAGEMENT_BASE_URL}/update-orders`, data);
export const addSubCategory = (data) =>
  Request.post(`${MANAGEMENT_BASE_URL}/add-subcategory`, data);

export const updateSubCategory = (id, data) => Request.put(`management/sub-categories/${id}`, data);
export const deleteSubCategory = (id) => Request.delete(`management/sub-categories/${id}`);
export const updateSubCategoryOrders = (data) =>
  Request.post(`management/sub-categories/update-orders`, data);

// Store And Management
